<template>
  <form>
    <div>
      <button
        v-if="!newProject"
        class="button is-success mb-10"
        :class="{'is-loading': saving}"
        @click.prevent="saveProject"
      >
        Save changes
      </button>
    </div>
    <div
      v-if="!newProject && presentationModeUrl"
      class="presentation-url box mb-20"
    >
      <label class="label" for="presentationModeUrl">Presentation Mode URL</label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <input
            id="presentationModeUrl"
            ref="presentationModeUrl"
            class="input"
            type="text"
            :value="presentationModeUrl"
            readonly
          >
        </div>
        <div class="control">
          <button
            class="button is-info"
            type="button"
            @click.prevent="copyPresentationModeUrl"
          >
            {{ presentationModeUrlCopied ? 'Copied' : 'Copy' }}
          </button>
        </div>
        <div class="control">
          <a
            class="button"
            :href="presentationModeUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open
          </a>
        </div>
      </div>
      <p v-if="presentationModeUrlCopyError" role="alert">
        {{ presentationModeUrlCopyError }}
      </p>
      <small>
        Use this link when DIMONice should auto-start, loop continuously,
        and check for new steps.
      </small>
    </div>
    <div>
      <div class="row">
        <!-- <div class="col-lg-6 justify-content-end">
          <div class="sc-bZQynM eboSGJ"><button

                type="button"
                label="app.utils.delete"
            ><span>Delete</span></button></div>
          <div class="sc-bZQynM eboSGJ"><button

                type="button"
                label="content-manager.containers.Edit.reset"
            ><span>Reset</span></button><button

                type="submit"
                label="content-manager.containers.Edit.submit"
            ><span>Save</span></button></div>
        </div> -->
      </div>
    </div>
    <div>
      <div class="frow gutters">
        <div class="col-sm-1-2">
          <div class="file has-name is-boxed">
            <label
                class="file-label"
                for="audio"
            >
              <input
                  id="audio"
                  class="file-input"
                  type="file"
                  @change="uploadAudio"
              />
              <span class="file-cta">
                <br />
                <span class="file-icon">
                  <i class="fas fa-file-audio fa-3x"></i>
                </span>
                <br />
                  <span class="file-label">
                    Upload Audio
                  </span>
                </span>
            </label>
          </div>
          <div v-if="hasBackgroundAudio">
            <div v-if="project.backgroundAudio.name">{{ project.backgroundAudio.name }}</div>
            <a
              :href="audioURL"
              target="_blank"
            >
              Preview Audio
            </a>
            <span
              class="has-text-danger delete-audio"
              @click="deleteAudio()"
            >
              Remove Audio
            </span>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="backgroundAudioVolume">Background Audio Volume</label>
            <small>Enter value between 0 and 1, like so 0.25 <br/> (0.25 would be 25%)</small>
            <input
                v-model="project.backgroundAudioVolume"
                class="input"
                id="backgroundAudioVolume"
                name="backgroundAudioVolume"
                type="number"
                min="0"
                max="1"
            >
          </div>
        </div>
      </div>
      <div class="frow gutters mb-20">
        <div class="col-sm-1-2">
          <div class="field">
          <label class="label" for="name">Name</label>
          <input
              v-model="project.name"
              class="input"
              id="name"
              name="name"
              type="text"
          >
        </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="domain">Domain</label>
            <input
                v-model="project.domain"
                class="input"
                id="domain"
                name="domain"
                type="text"
            >
          </div>
        </div>
      </div>
      <div class="frow gutters mb-20">
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="info">Loop Steps</label>
              <div class="frow justify-start">
                <input
                  v-model="project.loop"
                  type="checkbox"
                >
              </div>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="animate">Animate Steps</label>
              <div class="frow justify-start">
                <input
                  v-model="project.transition"
                  type="checkbox"
                >
              </div>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="interactiveQuotesEnabled">Enable Interactive Quotes</label>
            <div class="frow justify-start">
              <input
                id="interactiveQuotesEnabled"
                v-model="project.interactiveQuotesEnabled"
                name="interactiveQuotesEnabled"
                type="checkbox"
              >
            </div>
            <small>
              Allows public quote submissions and approved quote playback for this project.
            </small>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="info">Special Formatting</label>
            <div class="control">
              <div class="select">
                <select v-model="project.customStyle">
                  <option value="none">None</option>
                  <option value="notext4x3">No Text - 4x3</option>
                  <option value="widescreen16x9">16:9 Widescreen</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="googleAnalyticsID">Google Analytics ID</label>
            <input
                v-model="project.googleAnalyticsID"
                class="input"
                id="googleAnalyticsID"
                name="googleAnalyticsID"
                type="text"
            >
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label" for="info">Info</label>
        <textarea
            v-model="project.info"
            class="textarea"
            id="info"
            name="info"
            style="height: 196px;"
        ></textarea>
      </div>

      <div class="frow gutters mb-20">
        <div class="col-sm-1-6">
          <div class="field">
          <label class="label" for="backgroundColor">BackgroundColor</label>
          <input
              v-model="project.backgroundColor"
              class="input"
              id="backgroundColor"
              name="backgroundColor"
              type="text"
          >
        </div>
        </div>
        <div class="col-sm-1-6">
          <div class="field">
            <label class="label" for="buttonColor">ButtonColor</label>
            <input
                v-model="project.buttonColor"
                class="input"
                id="buttonColor"
                name="buttonColor"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-6">
          <div class="field">
            <label class="label" for="infoButtonColor">InfoButtonColor</label>
            <input
                v-model="project.infoButtonColor"
                class="input"
                id="infoButtonColor"
                name="infoButtonColor"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-6">
          <div class="field">
            <label class="label" for="arrowsColor">ArrowsColor</label>
            <input
                v-model="project.arrowsColor"
                class="input"
                id="arrowsColor"
                name="arrowsColor"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-6">
          <div class="field">
            <label class="label" for="sliderColor1">SliderColor1</label>
            <input
                v-model="project.sliderColor1"
                class="input"
                id="sliderColor1"
                name="sliderColor1"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-6">
          <div class="field">
            <label class="label" for="sliderColor2">SliderColor2</label>
            <input
                v-model="project.sliderColor2"
                class="input"
                id="sliderColor2"
                name="sliderColor2"
                type="text"
            >
          </div>
        </div>
      </div>

      <div class="frow gutters mb-20">
        <div class="col-sm-1-3">
          <div class="field">
            <label class="label" for="soundOnColor">SoundOnColor</label>
            <input
                v-model="project.soundOnColor"
                class="input"
                id="soundOnColor"
                name="soundOnColor"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-3">
          <div class="field">
            <label class="label" for="soundOffColor">SoundOffColor</label>
            <input
                v-model="project.soundOffColor"
                class="input"
                id="soundOffColor"
                name="soundOffColor"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-3">
          <div class="field">
            <label class="label" for="infoBackgroundColor">InfoBackgroundColor</label>
            <input
                v-model="project.infoBackgroundColor"
                class="input"
                id="infoBackgroundColor"
                name="infoBackgroundColor"
                type="text"
            >
          </div>
        </div>
      </div>

      <div class="frow gutters mb-20">
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="textFont">TextFont</label>
            <input
                v-model="project.textFont"
                class="input"
                id="textFont"
                name="textFont"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-2">
          <div class="field">
            <label class="label" for="fontUrl">FontUrl</label>
            <input
                v-model="project.fontUrl"
                class="input"
                id="fontUrl"
                name="fontUrl"
                type="text"
            >
          </div>
        </div>
      </div>

      <div class="frow gutters mb-20">
        <div class="col-sm-1-3">
          <div class="field">
            <label class="label" for="textColor">TextColor</label>
            <input
                v-model="project.textColor"
                class="input"
                id="textColor"
                name="textColor"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-3">
          <div class="field">
            <label class="label" for="stepTextSize">StepTextSize</label>
            <input
                v-model="project.stepTextSize"
                class="input"
                id="stepTextSize"
                name="stepTextSize"
                type="text"
            >
          </div>
        </div>
        <div class="col-sm-1-3">
          <div class="field">
            <label class="label" for="textShadow">
              TextShadow
              <small>(ex. #000000 1px 1px 5px)</small>
            </label>
            <input
                v-model="project.textShadow"
                class="input"
                id="textShadow"
                name="textShadow"
                type="text"
            >
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label" for="pageTitle">PageTitle</label>
        <input
            v-model="project.pageTitle"
            class="input"
            id="pageTitle"
            name="pageTitle"
            type="text"
        >
      </div>
      <div class="field">
        <label class="label" for="metaDescription">MetaDescription</label>
        <textarea
            v-model="project.metaDescription"
            class="textarea"
            id="metaDescription"
            name="metaDescription"
            style="height: 196px;"
        ></textarea>
      </div>
      <!-- <div class="field">
        <label class="label" for="maxWidth">MaxWidth</label>
        <input
            v-model="project.maxWidth"
            class="input"
            id="maxWidth"
            name="maxWidth"
            type="text"
        >
      </div> -->
    </div>
    <button
      v-if="!newProject"
      class="button is-success is-pulled-right mt-20"
      :class="{'is-loading': saving}"
      @click.prevent="saveProject"
    >
      Save changes
    </button>
  </form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'project-form',
  props: {
    project: {
      type: Object,
    },
    newProject: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      newAudio: null,
      saveNewProject: false,
      presentationModeUrlCopied: false,
      presentationModeUrlCopyError: '',
      presentationModeUrlCopyTimer: null,
      presentationModeUrlCopyRequest: 0,
    };
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      jwt: state => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
    hasBackgroundAudio() {
      return (this.project.backgroundAudio && this.project.backgroundAudio.url)
        || this.project.uploadedAudioUrl;
    },
    audioURL() {
      if (this.project.uploadedAudioUrl) {
        return this.project.uploadedAudioUrl;
      }
      return `${this.API}${this.project.backgroundAudio.url}`;
    },
    presentationModeUrl() {
      if (!this.project || !this.project.domain) {
        return '';
      }
      const domain = this.project.domain.replace(/^https?:\/\//, '').replace(/\/$/, '');
      const protocol = this.isLocalDomain(domain) ? 'http' : 'https';
      return `${protocol}://${domain}/?mode=presentation`;
    },
  },
  watch: {
    presentationModeUrl() {
      this.resetPresentationModeCopy();
    },
  },
  beforeDestroy() {
    this.resetPresentationModeCopy();
  },
  methods: {
    isLocalDomain(domain) {
      return /^(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/i.test(domain);
    },
    resetPresentationModeCopy() {
      this.presentationModeUrlCopyRequest += 1;
      clearTimeout(this.presentationModeUrlCopyTimer);
      this.presentationModeUrlCopyTimer = null;
      this.presentationModeUrlCopied = false;
      this.presentationModeUrlCopyError = '';
    },
    async copyPresentationModeUrl() {
      this.resetPresentationModeCopy();
      const request = this.presentationModeUrlCopyRequest;
      const url = this.presentationModeUrl;
      if (!url) return;
      let copied = false;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
          copied = true;
        }
      } catch (error) {
        // Permissions or an insecure context may deny the modern clipboard API.
      }
      // Only the newest live request may fall back, show feedback or own a timer.
      if (request !== this.presentationModeUrlCopyRequest
        || url !== this.presentationModeUrl) return;
      if (!copied) {
        const input = this.$refs.presentationModeUrl;
        try {
          if (input) {
            input.focus();
            input.select();
            input.setSelectionRange(0, url.length);
            copied = document.execCommand('copy') === true;
          }
        } catch (error) {
          copied = false;
        }
      }
      this.presentationModeUrlCopied = copied;
      if (!copied) {
        this.presentationModeUrlCopyError = 'Unable to copy automatically. Select the URL and copy it manually.';
        return;
      }
      this.presentationModeUrlCopyTimer = setTimeout(() => {
        if (request !== this.presentationModeUrlCopyRequest) return;
        this.presentationModeUrlCopied = false;
        this.presentationModeUrlCopyTimer = null;
      }, 2000);
    },
    deleteAudio() {
      // Existing admin UI uses the browser confirm for destructive deletes.
      // eslint-disable-next-line no-alert
      if (window.confirm('Are you sure you want to delete this audio file?')) {
        const url = `${this.$API}/upload/files/${this.project.backgroundAudio.id}`;
        this.axios({
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${this.jwt}`,
          },
          url,
        }).then(() => this.saveProject());
      }
    },
    saveProject() {
      this.saving = true;
      const method = this.newProject ? 'POST' : 'PUT';
      const url = `${this.$API}/projects/${this.newProject ? '' : this.project.id}`;
      const data = this.project;

      if (this.project.uploadedAudioUrl) {
        delete data.backgroundAudio;
        delete data.uploadedAudioUrl;
      }

      const projectData = { ...data };
      delete projectData.steps;

      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data: projectData,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            this.saving = false;
            // Emit event to parent with updated project data
            this.$emit('project-saved', response.data);
            // Update local project reference (for reactivity)
            Object.assign(this.project, response.data);
            if (this.newProject) {
              this.saveNewProject = true;
              this.uploadAudio(this.newAudio);
            }
          }
        })
        .catch((err) => {
          this.saving = false;
          console.log(err);
        });
    },
    uploadAudio(e) {
      if ((!this.newProject || this.saveNewProject) && e !== null) {
        const body = new FormData();

        body.append('refId', this.project.id);
        body.append('ref', 'project');
        body.append('field', 'backgroundAudio');
        body.append('files', e.target.files[0]);

        const request = new XMLHttpRequest();

        request.onreadystatechange = () => {
          if (request.readyState === XMLHttpRequest.DONE) {
            this.$set(this.project, 'uploadedAudioUrl', JSON.parse(request.response)[0].url);
          }
        };

        request.open('POST', `${this.$API}/upload`);
        request.setRequestHeader('Authorization', `Bearer ${this.jwt}`);
        request.send(body);
        this.saveNewProject = false;
      } else {
        this.newAudio = e;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
form {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 700px;
}
label {
  text-align: left;
}
select {
  background-image: none;
}
.delete-audio {
  cursor: pointer;
}
</style>
